import Block from 'quill/blots/block';

const HINTS = ['info', 'success', 'warning', 'error'] as const;
export type HintType = (typeof HINTS)[number];

export const HINT_LABELS: Record<HintType, string> = {
  info: 'Note',
  success: 'Tip',
  warning: 'Warn',
  error: 'Error',
};

class Hint extends Block {
  static create(value: string) {
    const domNode = super.create(value);
    if (typeof value === 'string') {
      domNode.setAttribute('data-hint', value);
    }
    return domNode;
  }

  static formats(domNode: HTMLElement) {
    return domNode.getAttribute('data-hint') || HINTS[0];
  }

  format(name: string, value: unknown) {
    if (
      name === this.statics.blotName &&
      typeof value === 'string' &&
      HINTS.includes(value as HintType)
    ) {
      this.domNode.setAttribute('data-hint', value);
    } else {
      super.format(name, value);
    }
  }
}
Hint.blotName = 'hint';
Hint.className = 'ql-hint';
Hint.tagName = 'DIV';

export default Hint;
